module.exports = __webpack_public_path__ + "img/product.b9b52213.svg";